/* hvs-optimisation 2026-11-04: the reader's climate on collection, search and product pages. No dependencies.
   The zone: localStorage "hvs-zone", shared with the Learning Hub, What to sow now and the Learn panel, so a reader who has
   chosen once on any of them is never asked again. A postcode finds it in one step.
   The card: snippets/hvs-sow-band.liquid carries each product's months for all six zones. This script writes the line under
   the photograph for the reader's zone and this month, and a tap opens the seed's calendar, with the six zones to compare.
   On a product page the same line sits beside the price, and asks where the reader gardens when it does not know: that page
   has no bar to ask from. Similar Products and Recently viewed arrive by fetch, so an observer paints their cards.
   Sow now: one tap filters the whole collection, every page of it, through the store's own filters. The counts come from the
   server in snippets/hvs-climate-bar.liquid; the theme's script redraws the grid, so this script only asks it to.
   When to sow: twelve months in the filter panel for the reader's zone, starting at this month. Real checkboxes with the
   theme's names, so its filter script treats them like any other.
   Zone names, places and postcodes are written into this file from assets/hvs-sow.js when the pack is built (tools/apply.py).
   Analytics: zone_set, sow_now_toggle, sow_sheet_open, filter_change to the site's gtag, when present. */
(function () {
  'use strict';
  if (window.HVSClimate) { return; }

  var ZONES = [ { k: 'tropical', n: 'Tropical', c: 'Darwin, Katherine NT; Cairns, Townsville QLD; Broome WA' }, { k: 'subtropical', n: 'Subtropical', c: 'Brisbane, Gold Coast, Bundaberg QLD; Coffs Harbour, Lismore NSW' }, { k: 'arid', n: 'Arid and semi-arid', c: 'Alice Springs NT; Broken Hill, Dubbo NSW; Mildura VIC; Kalgoorlie WA; Port Augusta SA; Longreach QLD' }, { k: 'temperate', n: 'Temperate', c: 'Sydney, Newcastle, Wollongong NSW; Melbourne, Geelong VIC' }, { k: 'mediterranean', n: 'Mediterranean', c: 'Perth, Bunbury and southern WA; Adelaide and the SA coast' }, { k: 'cool', n: 'Cool and alpine', c: 'Hobart, Launceston TAS; Canberra ACT; Ballarat VIC; Orange, Armidale NSW; Stanthorpe QLD' } ];
  var PC = [[200, 299, 'cool'], [800, 859, 'tropical'], [860, 879, 'arid'], [880, 899, 'tropical'], [1000, 1999, 'temperate'], [2000, 2339, 'temperate'], [2340, 2379, 'cool'], [2380, 2411, 'arid'], [2412, 2439, 'temperate'], [2440, 2490, 'subtropical'], [2491, 2575, 'temperate'], [2576, 2599, 'cool'], [2600, 2639, 'cool'], [2640, 2674, 'temperate'], [2675, 2717, 'arid'], [2718, 2730, 'temperate'], [2731, 2739, 'arid'], [2740, 2779, 'temperate'], [2780, 2820, 'cool'], [2821, 2849, 'arid'], [2850, 2868, 'temperate'], [2869, 2898, 'arid'], [2899, 2999, 'temperate'], [3000, 3345, 'temperate'], [3346, 3364, 'cool'], [3365, 3439, 'temperate'], [3440, 3464, 'cool'], [3465, 3479, 'temperate'], [3480, 3512, 'arid'], [3513, 3524, 'temperate'], [3525, 3549, 'arid'], [3550, 3578, 'temperate'], [3579, 3599, 'arid'], [3600, 3691, 'temperate'], [3692, 3799, 'cool'], [3800, 3899, 'temperate'], [3900, 3909, 'cool'], [3910, 3999, 'temperate'], [4000, 4369, 'subtropical'], [4370, 4385, 'cool'], [4386, 4469, 'subtropical'], [4470, 4499, 'arid'], [4500, 4712, 'subtropical'], [4713, 4739, 'arid'], [4740, 4820, 'tropical'], [4821, 4829, 'arid'], [4830, 4999, 'tropical'], [5000, 5299, 'mediterranean'], [5300, 5349, 'arid'], [5350, 5429, 'mediterranean'], [5430, 5440, 'arid'], [5441, 5599, 'mediterranean'], [5600, 5600, 'arid'], [5601, 5689, 'mediterranean'], [5690, 5799, 'arid'], [5800, 5999, 'mediterranean'], [6000, 6419, 'mediterranean'], [6420, 6449, 'arid'], [6450, 6629, 'mediterranean'], [6630, 6699, 'arid'], [6700, 6700, 'tropical'], [6701, 6709, 'arid'], [6710, 6750, 'tropical'], [6751, 6758, 'arid'], [6759, 6799, 'tropical'], [6800, 6999, 'mediterranean'], [7000, 7999, 'cool'], [8000, 8999, 'temperate'], [9000, 9999, 'subtropical']];
  var FK = { tropical: 'tropical', subtropical: 'subtropical', arid: 'arid', temperate: 'warm_temperate', mediterranean: 'mediterranean', cool: 'cool_temperate' };
  var PFX = 'filter.p.m.sowing.';
  var KEY = 'hvs-zone';
  var M3 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MF = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var ML = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
  var CUR = new Date().getMonth();
  var ICON_CAL = '<svg class="hvs-sline__ico" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect x="2.2" y="3.2" width="11.6" height="10.6" rx="2"/><path d="M2.2 6.6h11.6M5.4 1.8v2.6M10.6 1.8v2.6"/></svg>';
  var ICON_CHEV = '<svg class="hvs-sline__chev" width="10" height="10" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M4.5 2.5 8 6l-3.5 3.5"/></svg>';
  var ICON_X = '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 5l10 10M15 5 5 15"/></svg>';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function coarse() { return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches); }
  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') { window.gtag('event', name, params || {}); }
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params || {})); }
    } catch (e) {}
  }
  /* The quick shop's live region where it is loaded. A product page does not load it, so that page gets one of its own. */
  function announce(text) {
    if (window.HVSQuickShop && window.HVSQuickShop.announce) { window.HVSQuickShop.announce(text); return; }
    var r = $('#hvs-climate-live'), fresh = !r;
    if (fresh) { r = document.createElement('div'); r.id = 'hvs-climate-live'; r.className = 'visually-hidden'; r.setAttribute('aria-live', 'polite'); document.body.appendChild(r); }
    setTimeout(function () { r.textContent = text; }, fresh ? 120 : 0);
  }
  function zoneOf(k) { for (var i = 0; i < ZONES.length; i++) { if (ZONES[i].k === k) { return ZONES[i]; } } return null; }
  function page() { return (window.theme && window.theme.pageType) || ''; }

  /* ---- the zone ---- */
  function stored() { try { var z = localStorage.getItem(KEY); return z && zoneOf(z) ? z : ''; } catch (e) { return ''; } }
  /* A link with a sowing filter in it says which zone its results are for. It wins for this view and is not saved. */
  function urlSow() {
    var sp = new URLSearchParams(window.location.search), out = null;
    ZONES.some(function (z) {
      var v = sp.getAll(PFX + FK[z.k]);
      if (v.length) { out = { zone: z.k, months: v }; return true; }
      return false;
    });
    return out;
  }
  function zone() { var u = urlSow(); return (u && u.zone) || stored(); }
  function findPostcode(text) {
    var n = parseInt(String(text).replace(/\D/g, ''), 10);
    if (!(n > 0)) { return ''; }
    for (var i = 0; i < PC.length; i++) { if (n >= PC[i][0] && n <= PC[i][1]) { return PC[i][2]; } }
    return '';
  }

  /* ---- months and words ---- */
  function monthsOf(text) {
    return String(text || '').split(',').map(function (m) { return M3.indexOf(m.trim()); }).filter(function (i) { return i >= 0; });
  }
  function windowsOf(btn) {
    var parts = String(btn.getAttribute('data-hvs-sline') || '').split('|'), out = {};
    ['tropical', 'subtropical', 'arid', 'temperate', 'mediterranean', 'cool'].forEach(function (k, i) { out[k] = monthsOf(parts[i]); });
    /* As What to sow now does: a blank Mediterranean reads Temperate. */
    if (!out.mediterranean.length) { out.mediterranean = out.temperate; }
    return out;
  }
  /* Runs of months, read round the year and starting from this month: "October to February, April". */
  function runs(ms) {
    if (!ms.length) { return []; }
    if (ms.length >= 12) { return [[0, 11]]; }
    var seen = [], out = [], i, m;
    for (i = 0; i < 12; i++) { seen[i] = ms.indexOf(i) !== -1; }
    var start = CUR; /* begin at a gap, so a run is never cut in two */
    for (i = 0; i < 12; i++) { m = (CUR + i) % 12; if (!seen[m]) { start = m; break; } }
    var run = null;
    for (i = 0; i <= 12; i++) {
      m = (start + i) % 12;
      if (i < 12 && seen[m]) { if (!run) { run = [m, m]; } else { run[1] = m; } }
      else if (run) { out.push(run); run = null; }
    }
    /* The run holding this month, or the next to come, goes first. */
    out.sort(function (a, b) { return ((a[0] - CUR + 12) % 12) - ((b[0] - CUR + 12) % 12); });
    var at = -1;
    out.forEach(function (r, x) { var len = (r[1] - r[0] + 12) % 12, off = (CUR - r[0] + 12) % 12; if (off <= len) { at = x; } });
    if (at > 0) { out = out.slice(at).concat(out.slice(0, at)); }
    return out;
  }
  function words(ms) {
    if (ms.length >= 12) { return 'every month'; }
    return runs(ms).map(function (r) { return r[0] === r[1] ? MF[r[0]] : MF[r[0]] + ' to ' + MF[r[1]]; }).join(', ');
  }
  /* What a card says. a: the words that always show. b: the words that follow when the card has room for them. long: the sentence. */
  function stateOf(ms, verb, zname) {
    var V = verb === 'plant' ? 'Plant' : 'Sow', v = V.toLowerCase();
    if (!ms.length) { return { k: 'none', a: 'Not suited', b: 'here', long: 'Not suited to the ' + zname + ' zone' }; }
    if (ms.length >= 12) { return { k: 'now', a: V + ' any month', b: '', long: V + ' any month' }; }
    if (ms.indexOf(CUR) !== -1) {
      if (ms.indexOf((CUR + 1) % 12) === -1) { return { k: 'last', a: 'Last month', b: 'to ' + v, long: 'Last month to ' + v + ' here' }; }
      var end = CUR, i;
      for (i = 0; i < 11; i++) { if (ms.indexOf((end + 1) % 12) !== -1) { end = (end + 1) % 12; } else { break; } }
      return { k: 'now', a: V + ' now', b: 'until ' + M3[end], long: V + ' now, until ' + MF[end] };
    }
    var next = CUR;
    for (i = 1; i < 12; i++) { var m = (CUR + i) % 12; if (ms.indexOf(m) !== -1) { next = m; break; } }
    return { k: next === (CUR + 1) % 12 ? 'soon' : 'later', a: V + ' from ' + M3[next], b: '', long: V + ' from ' + MF[next] };
  }

  /* ---- the card's line ---- */
  function titleOf(btn) {
    var card = btn.closest('.product-item'), t = card ? $('.product-item__title', card) : $('.product-meta__title');
    return t ? t.textContent.trim() : '';
  }
  function paintBands() {
    var z = zone(), zo = zoneOf(z);
    $$('[data-hvs-sline]').forEach(function (b) {
      var big = b.closest('.hvs-pline'), verb = b.getAttribute('data-hvs-verb');
      if (big) { big.classList.toggle('is-asking', !zo); }
      if (!zo && !big) { b.hidden = true; b.setAttribute('data-hvs-painted', 'none'); return; }
      if (!zo) {
        if (b.getAttribute('data-hvs-painted') !== 'ask') {
          b.className = 'hvs-sline is-ask';
          b.innerHTML = ICON_CAL + '<span class="hvs-sline__t"><span>Where do you garden?</span></span>' + ICON_CHEV;
          b.setAttribute('aria-label', 'Where do you garden? Choose your climate zone to see when to ' + (verb === 'plant' ? 'plant' : 'sow') + ' this.');
          b.setAttribute('aria-haspopup', 'dialog');
          b.setAttribute('data-hvs-painted', 'ask');
        }
        b.hidden = false;
        return;
      }
      var ms = windowsOf(b)[z], st = stateOf(ms, verb, zo.n), sig = z + CUR;
      b.className = 'hvs-sline is-' + st.k;
      if (b.getAttribute('data-hvs-painted') !== sig) {
        b.innerHTML = ICON_CAL + '<span class="hvs-sline__t"><span>' + esc(st.a) + '</span>' + (st.b ? ' <span class="hvs-sline__more">' + esc(st.b) + '</span>' : '') + (big ? '<span class="hvs-sline__zone">' + esc(zo.n) + '</span>' : '') + '</span>' + (big ? ICON_CHEV : '');
        b.setAttribute('aria-label', (titleOf(b) ? titleOf(b) + ': ' : '') + st.long + (big ? ', ' + zo.n + ' zone' : '') + '. See the sowing months.');
        b.setAttribute('aria-haspopup', 'dialog');
        b.setAttribute('data-hvs-painted', sig);
      }
      b.hidden = false;
    });
  }

  /* ---- the bar, and When to sow in the filter panel ---- */
  function counts() {
    var el = $('[data-hvs-sow-counts]');
    if (!el) { return null; }
    try {
      var c = JSON.parse(el.textContent), any = false;
      Object.keys(c).forEach(function (z) { Object.keys(c[z]).forEach(function (m) { if (c[z][m][0] > 0 || c[z][m][1]) { any = true; } }); });
      return any ? c : null;
    } catch (e) { return null; }
  }
  /* What Sow now acts on: this month, or if nothing here can be sown this month, the next month that has something. */
  function nowTarget(z, c) {
    var zc = c && c[FK[z]];
    if (!zc) { return null; }
    var v = zc[M3[CUR]] || [0, 0];
    if (v[0] > 0 || v[1]) { return { m: CUR, n: v[0], now: true, on: !!v[1] }; }
    for (var i = 1; i < 12; i++) {
      var m = (CUR + i) % 12, w = zc[M3[m]];
      if (w && w[0] > 0) { return { m: m, n: w[0], now: false, on: !!w[1] }; }
    }
    return null;
  }
  function verbOfPage() {
    var bands = $$('[data-hvs-sline]');
    if (!bands.length) { return 'sow'; }
    return bands.every(function (b) { return b.getAttribute('data-hvs-verb') === 'plant'; }) ? 'plant' : 'sow';
  }
  function paintBar() {
    var z = zone(), zo = zoneOf(z), c = counts(), verb = verbOfPage(), V = verb === 'plant' ? 'Plant' : 'Sow';
    $$('[data-hvs-climate-label]').forEach(function (l) { l.textContent = zo ? zo.n : 'Where do you garden?'; });
    $$('.hvs-climate__zone').forEach(function (b) {
      b.classList.toggle('is-set', !!zo);
      b.setAttribute('aria-label', zo ? 'Your climate zone is ' + zo.n + '. Change it.' : 'Where do you garden? Choose your climate zone.');
    });
    var now = $('[data-hvs-sow-now]');
    if (now) {
      var t = zo ? nowTarget(z, c) : null, text = $('[data-hvs-sow-now-text]', now), nEl = $('[data-hvs-sow-now-n]', now);
      if (!c || (zo && !t)) { now.hidden = true; }
      else {
        now.hidden = false;
        if (!zo) {
          text.textContent = V + ' now'; nEl.textContent = ''; now.setAttribute('aria-pressed', 'false'); now.classList.remove('is-on');
          now.removeAttribute('data-hvs-m');
          now.setAttribute('aria-label', V + ' now. Choose your climate zone first.');
        } else {
          text.textContent = t.now ? V + ' now' : V + ' from ' + M3[t.m];
          nEl.textContent = String(t.n);
          now.setAttribute('aria-pressed', String(t.on));
          now.classList.toggle('is-on', t.on);
          now.setAttribute('data-hvs-m', String(t.m));
          now.setAttribute('aria-label', (t.now ? V + ' now in ' + MF[t.m] : V + ' from ' + MF[t.m]) + ', ' + zo.n + ' zone, ' + t.n + (t.n === 1 ? ' result' : ' results'));
        }
      }
    }
    var bar = $('[data-hvs-climate]'), count = $('.hvs-learn__count');
    if (bar && count && bar.getAttribute('data-hvs-total')) { count.textContent = bar.getAttribute('data-hvs-total'); }
    paintMonths(z, zo, c, verb);
    paintEmpty(z, zo, c, verb);
  }
  function paintMonths(z, zo, c, verb) {
    $$('[data-hvs-sow-group]').forEach(function (group) {
      group.hidden = !c;
      if (!c) { return; }
      var box = $('[data-hvs-sow-months]', group), pre = box.getAttribute('data-hvs-prefix') || 'd';
      var title = $('[data-hvs-sow-group-title]', group), change = $('[data-hvs-sow-group-change]', group);
      var noun = verb === 'plant' ? 'plant' : 'sow';
      title.textContent = zo ? 'When to ' + noun + ' in ' + zo.n : 'When to ' + noun;
      change.hidden = !zo;
      if (!zo) {
        box.innerHTML = '<p class="hvs-sow-group__ask">Tell us where you garden and this shows the months for your climate.</p><button type="button" class="hvs-sow-group__set" data-hvs-climate-open aria-haspopup="dialog">Where do you garden?</button>';
        return;
      }
      var zc = c[FK[z]] || {}, name = PFX + FK[z], html = '<div class="hvs-smons">';
      for (var i = 0; i < 12; i++) {
        var m = (CUR + i) % 12, v = zc[M3[m]] || [0, 0], id = 'hvs-smon-' + pre + '-' + M3[m], zero = !v[0] && !v[1];
        html += '<label class="hvs-smon' + (i === 0 ? ' is-this' : '') + (v[1] ? ' is-on' : '') + (zero ? ' is-zero' : '') + '" for="' + id + '">' +
          '<input type="checkbox" class="hvs-smon__box" id="' + id + '" name="' + esc(name) + '" value="' + M3[m] + '"' + (v[1] ? ' checked' : '') + (zero ? ' disabled' : '') + '>' +
          '<span class="hvs-smon__m">' + M3[m] + (i === 0 ? '<span class="visually-hidden">, this month</span>' : '') + '</span><span class="hvs-smon__n">' + v[0] + '<span class="visually-hidden"> ' + (v[0] === 1 ? 'result' : 'results') + '</span></span></label>';
      }
      box.innerHTML = html + '</div>';
    });
  }
  /* No results because of a sowing month: say so, and offer the next month that has something. */
  function paintEmpty(z, zo, c, verb) {
    var box = $('.collection__dynamic-part .empty-state'), u = urlSow();
    if (!box || !u || !zo) { return; }
    var d = $('.empty-state__description', box); if (!d) { return; }
    var noun = verb === 'plant' ? 'plant' : 'sow', names = u.months.map(function (x) { return MF[M3.indexOf(x)] || x; }).join(' or ');
    d.textContent = 'Nothing here to ' + noun + ' in ' + names + ' in the ' + zo.n + ' zone.';
    var t = nowTarget(z, c), wrap = $('.empty-state__button-container', box);
    if (t && wrap && !$('[data-hvs-empty-next]', wrap)) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'empty-state__button button button--secondary'; b.setAttribute('data-hvs-empty-next', String(t.m));
      b.textContent = 'Show ' + MF[t.m] + ' (' + t.n + ')';
      wrap.insertBefore(b, wrap.firstChild);
    }
  }
  function paintAll() { paintBands(); paintBar(); }

  /* ---- asking the theme to redraw ---- */
  function themeGo(href) {
    var part = $('.collection__dynamic-part'), sec = part && part.closest('[data-section-id]');
    if (!sec) { window.location.assign(href); return; }
    var b = document.createElement('button');
    b.type = 'button'; b.hidden = true; b.setAttribute('data-action', 'clear-filters'); b.setAttribute('data-url', href);
    sec.appendChild(b); b.click(); sec.removeChild(b);
  }
  function hrefWith(change) {
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    change(u.searchParams);
    return u.pathname + '?' + u.searchParams.toString();
  }
  function toggleMonth(z, m, on) {
    themeGo(hrefWith(function (sp) {
      var p = PFX + FK[z], vals = sp.getAll(p).filter(function (x) { return x !== M3[m]; });
      sp.delete(p);
      if (on) { vals.push(M3[m]); }
      vals.forEach(function (x) { sp.append(p, x); });
    }));
  }
  /* The reader moved zone while a sowing filter is on: the same months, for the new zone. */
  function carryFilter(z) {
    var u = urlSow();
    if (!u || u.zone === z) { return false; }
    themeGo(hrefWith(function (sp) {
      sp.delete(PFX + FK[u.zone]);
      u.months.forEach(function (x) { sp.append(PFX + FK[z], x); });
    }));
    return true;
  }

  /* ---- setting the zone ---- */
  var pendingSow = false, pendingLine = null, pcTimer = null;
  function setZone(z, method) {
    if (!zoneOf(z)) { return; }
    try { localStorage.setItem(KEY, z); } catch (e) {}
    document.documentElement.setAttribute('data-hvs-zone', z);
    if (window.HVSQuickShop && window.HVSQuickShop.applyZone) { window.HVSQuickShop.applyZone(z, false); }
    track('zone_set', { zone: z, method: method, page: page() });
    afterZone(z);
    if (sheetData) { fillSheet(); }
    announce('Your climate zone is ' + zoneOf(z).n + '.');
  }
  function afterZone(z) {
    var carried = carryFilter(z);
    paintAll();
    if (pendingSow && !carried) {
      pendingSow = false;
      var t = nowTarget(z, counts());
      if (t && !t.on) { toggleMonth(z, t.m, true); track('sow_now_toggle', { on: true, zone: z, month: M3[t.m], collection: handle() }); }
    }
  }
  function handle() { var m = window.location.pathname.match(/\/collections\/([^/?]+)/); return m ? m[1] : ''; }

  /* ---- dialogs ---- */
  function lock() { document.documentElement.classList.toggle('hvs-key-lock', $$('dialog[open]').length > 0); }
  function closeOf(sel) { var d = $(sel); if (d && d.open) { d.close(); } }
  function climateDialog() {
    var d = $('#hvs-climate-dialog');
    if (d) { return d; }
    var zones = ZONES.map(function (z) {
      return '<button type="button" class="hvs-cz__zone" data-hvs-cz-zone="' + z.k + '" aria-pressed="false"><span class="hvs-cz__n">' + esc(z.n) + '</span><span class="hvs-cz__c">' + esc(z.c) + '</span></button>';
    }).join('');
    d = document.createElement('dialog');
    d.className = 'hvs-key hvs-cz'; d.id = 'hvs-climate-dialog'; d.setAttribute('aria-labelledby', 'hvs-cz-title');
    d.innerHTML = '<div class="hvs-key__head"><h2 class="hvs-key__title" id="hvs-cz-title">Where do you garden?</h2><button type="button" class="hvs-key__close" data-hvs-cz-close aria-label="Close">' + ICON_X + '</button></div>' +
      '<div class="hvs-cz__body">' +
      '<form class="hvs-cz__pc" data-hvs-cz-pc novalidate><label class="hvs-cz__label" for="hvs-cz-pc">Your postcode</label><div class="hvs-cz__pcrow"><input class="hvs-cz__input" id="hvs-cz-pc" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" autocomplete="postal-code" enterkeyhint="done" placeholder="3000"><button type="submit" class="hvs-cz__find">Find my zone</button></div><p class="hvs-cz__found" data-hvs-cz-found aria-live="polite"></p></form>' +
      '<p class="hvs-cz__or">Or choose your zone</p><div class="hvs-cz__zones" role="group" aria-label="Climate zone">' + zones + '</div>' +
      '<p class="hvs-cz__note">Zones are broad groupings. If you sit between two, go by your local frost dates and how warm your soil is.</p>' +
      '<p class="hvs-cz__links"><a href="/pages/what-to-sow-now" data-hvs-cz-sow>What to sow now, for every crop</a><button type="button" class="hvs-cz__forget" data-hvs-cz-forget>Forget my zone</button></p></div>';
    d.addEventListener('close', function () {
      pendingSow = false; if (pcTimer) { clearTimeout(pcTimer); pcTimer = null; } lock();
      /* They asked when to sow this seed and had to say where first: now answer what they asked. */
      var line = pendingLine; pendingLine = null;
      if (line && line.isConnected && zoneOf(zone())) { openSheet(line); }
    });
    document.body.appendChild(d);
    return d;
  }
  function openClimate() {
    var d = climateDialog(), z = zone(), f = $('[data-hvs-cz-found]', d), i = $('#hvs-cz-pc', d);
    if (f) { f.textContent = ''; f.classList.remove('is-bad'); }
    if (i) { i.value = ''; }
    $$('[data-hvs-cz-zone]', d).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hvs-cz-zone') === z)); });
    var forget = $('[data-hvs-cz-forget]', d); if (forget) { forget.hidden = !stored(); }
    if (!d.open) { d.showModal(); lock(); }
    /* On a phone the keyboard stays shut until the reader wants it; with a real keyboard, go straight to the postcode. */
    if (i && !coarse()) { try { i.focus({ preventScroll: true }); } catch (e) { i.focus(); } }
    if (d.scrollTo) { d.scrollTo(0, 0); }
  }
  function submitPostcode() {
    var d = climateDialog(), i = $('#hvs-cz-pc', d), f = $('[data-hvs-cz-found]', d), text = (i.value || '').trim();
    if (!/^\d{3,4}$/.test(text)) { f.textContent = 'Please enter your four digit postcode.'; f.classList.add('is-bad'); return; }
    var z = findPostcode(text);
    if (!z) { f.textContent = 'We could not place ' + text + '. Please choose your zone below.'; f.classList.add('is-bad'); return; }
    f.classList.remove('is-bad');
    f.textContent = text + ' is in the ' + zoneOf(z).n + ' zone.';
    $$('[data-hvs-cz-zone]', d).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hvs-cz-zone') === z)); });
    if (i.blur) { i.blur(); }
    /* A moment to read which zone the postcode found. Closing the panel in that moment changes nothing. */
    if (pcTimer) { clearTimeout(pcTimer); }
    pcTimer = setTimeout(function () { pcTimer = null; setZone(z, 'postcode'); if (d.open) { d.close(); } }, 750);
  }

  /* The sowing calendar for one seed. */
  var sheetData = null;
  function strip(ms, withLetters) {
    var html = '<ol class="hvs-cal__strip' + (withLetters ? ' has-letters' : '') + '" aria-hidden="true">';
    for (var i = 0; i < 12; i++) {
      html += '<li class="' + (ms.indexOf(i) !== -1 ? 'is-sow' : '') + (i === CUR ? ' is-this' : '') + '">' + (withLetters ? ML[i] : '') + '</li>';
    }
    return html + '</ol>';
  }
  function sheet() {
    var d = $('#hvs-sow-sheet');
    if (d) { return d; }
    d = document.createElement('dialog');
    d.className = 'hvs-key hvs-cal'; d.id = 'hvs-sow-sheet'; d.setAttribute('aria-labelledby', 'hvs-cal-title');
    d.innerHTML = '<div class="hvs-key__head"><h2 class="hvs-key__title hvs-cal__title" id="hvs-cal-title"></h2><button type="button" class="hvs-key__close" data-hvs-cal-close aria-label="Close">' + ICON_X + '</button></div><div class="hvs-cal__body" data-hvs-cal-body></div>';
    d.addEventListener('close', function () { sheetData = null; lock(); });
    document.body.appendChild(d);
    return d;
  }
  function fillSheet() {
    var D = sheetData; if (!D) { return; }
    var d = sheet(), z = zone(), zo = zoneOf(z), body = $('[data-hvs-cal-body]', d), noun = D.verb === 'plant' ? 'planting' : 'sowing';
    $('#hvs-cal-title', d).textContent = D.title;
    if (!zo) { return; }
    var ms = D.win[z], st = stateOf(ms, D.verb, zo.n), wasOpen = false;
    var was = $('details', body); if (was) { wasOpen = was.open; }
    var facts = [];
    function nice(t) { return String(t).toLowerCase().replace(/^./, function (c) { return c.toUpperCase(); }).replace(/\//g, ' or '); }
    if (D.sun) { facts.push(['Sun', nice(D.sun)]); }
    if (D.frost) { facts.push(['Frost', nice(D.frost)]); }
    if (D.method) { facts.push(['How to start', nice(D.method)]); }
    if (D.days[0]) { facts.push(['Days to maturity', D.days[1] && D.days[1] !== D.days[0] ? D.days[0] + ' to ' + D.days[1] : D.days[0]]); }
    var others = ZONES.map(function (o) {
      var m = D.win[o.k];
      return '<li class="hvs-cal__row' + (o.k === z ? ' is-mine' : '') + '"><span class="hvs-cal__zn">' + esc(o.n) + '<span class="visually-hidden">: ' + esc(m.length ? words(m) : 'not suited') + '</span></span>' + strip(m, false) + '</li>';
    }).join('');
    body.innerHTML =
      '<p class="hvs-cal__state is-' + st.k + '">' + ICON_CAL + '<span>' + esc(st.long) + '</span></p>' +
      '<p class="hvs-cal__zone">In the <b>' + esc(zo.n) + '</b> zone <button type="button" class="hvs-cal__change" data-hvs-climate-open aria-haspopup="dialog">Change</button></p>' +
      strip(ms, true) +
      '<p class="hvs-cal__words">' + (ms.length ? esc(noun.charAt(0).toUpperCase() + noun.slice(1)) + ' months here: ' + esc(words(ms)) + '.' : 'Our calendar has no ' + noun + ' months for this zone. The other zones are below.') + '</p>' +
      '<details class="hvs-cal__all"' + (wasOpen || !ms.length ? ' open' : '') + '><summary>Compare all six zones</summary><ol class="hvs-cal__rows hvs-cal__head" aria-hidden="true"><li class="hvs-cal__row"><span class="hvs-cal__zn"></span><ol class="hvs-cal__strip has-letters is-key">' + ML.map(function (l, i) { return '<li' + (i === CUR ? ' class="is-this"' : '') + '>' + l + '</li>'; }).join('') + '</ol></li></ol><ul class="hvs-cal__rows">' + others + '</ul></details>' +
      (facts.length ? '<dl class="hvs-cal__facts">' + facts.map(function (f) { return '<div><dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd></div>'; }).join('') + '</dl>' : '') +
      '<p class="hvs-cal__links">' + (D.guide ? '<a class="hvs-cal__link" href="' + esc(D.guide) + '" data-hvs-cal-guide>Read the grow guide</a>' : '') + (D.url ? '<a class="hvs-cal__link" href="' + esc(D.url) + '">See this ' + (D.verb === 'plant' ? 'product' : 'seed') + '</a>' : '') + '</p>' +
      '<p class="hvs-cal__note">Zones are broad groupings. Your local frost dates and soil warmth come first.</p>';
  }
  function openSheet(btn) {
    var card = btn.closest('.product-item'), link = card && $('a.product-item__image-wrapper, a.product-item__title', card);
    var days = String(btn.getAttribute('data-hvs-days') || '').split('|');
    sheetData = {
      title: titleOf(btn), win: windowsOf(btn), verb: btn.getAttribute('data-hvs-verb'), sun: btn.getAttribute('data-hvs-sun'),
      frost: btn.getAttribute('data-hvs-frost'), method: btn.getAttribute('data-hvs-method'), days: days,
      guide: btn.getAttribute('data-hvs-guide'), url: link ? link.getAttribute('href') : ''
    };
    fillSheet();
    var d = sheet();
    if (!d.open) { d.showModal(); lock(); }
    if (d.scrollTo) { d.scrollTo(0, 0); }
    track('sow_sheet_open', { product: card ? card.getAttribute('data-product-handle') || '' : (window.location.pathname.match(/\/products\/([^/?]+)/) || ['', ''])[1], zone: zone(), state: btn.className.replace('hvs-sline is-', ''), page: page() });
  }

  /* ---- events ---- */
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) { return; }
    var a;
    if ((a = t.closest('[data-hvs-sline]'))) {
      e.preventDefault();
      if (zoneOf(zone())) { openSheet(a); } else { pendingLine = a; openClimate(); }
      return;
    }
    if (t.closest('[data-hvs-climate-open]')) { openClimate(); return; }
    if ((a = t.closest('[data-hvs-sow-now]'))) {
      var z = zone();
      if (!zoneOf(z)) { pendingSow = true; openClimate(); return; }
      var tg = nowTarget(z, counts());
      if (tg) {
        toggleMonth(z, tg.m, !tg.on);
        track('sow_now_toggle', { on: !tg.on, zone: z, month: M3[tg.m], collection: handle() });
        announce(tg.on ? 'Showing everything in this list.' : 'Showing what you can ' + (verbOfPage() === 'plant' ? 'plant' : 'sow') + ' in ' + MF[tg.m] + '.');
      }
      return;
    }
    if ((a = t.closest('[data-hvs-empty-next]'))) { toggleMonth(zone(), parseInt(a.getAttribute('data-hvs-empty-next'), 10), true); return; }
    if ((a = t.closest('[data-hvs-cz-zone]'))) { setZone(a.getAttribute('data-hvs-cz-zone'), 'chip'); closeOf('#hvs-climate-dialog'); return; }
    if (t.closest('[data-hvs-cz-close]')) { closeOf('#hvs-climate-dialog'); return; }
    if (t.closest('[data-hvs-cz-forget]')) {
      try { localStorage.removeItem(KEY); } catch (err) {}
      document.documentElement.setAttribute('data-hvs-zone', '');
      if (window.HVSQuickShop && window.HVSQuickShop.applyZone) { window.HVSQuickShop.applyZone('', false); }
      closeOf('#hvs-climate-dialog'); closeOf('#hvs-sow-sheet'); paintAll(); track('zone_set', { zone: '', method: 'forget', page: page() });
      return;
    }
    if (t.closest('[data-hvs-cal-close]')) { closeOf('#hvs-sow-sheet'); return; }
    /* A tap on the backdrop lands on the dialog itself. */
    if (t.matches && (t.matches('#hvs-climate-dialog') || t.matches('#hvs-sow-sheet'))) {
      var r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { t.close(); }
    }
  });
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-hvs-cz-pc]')) { e.preventDefault(); submitPostcode(); }
  });
  document.addEventListener('input', function (e) {
    var t = e.target; if (!t || t.id !== 'hvs-cz-pc') { return; }
    t.value = t.value.replace(/\D/g, '').slice(0, 4);
    var f = $('[data-hvs-cz-found]'); if (f) { f.textContent = ''; f.classList.remove('is-bad'); }
    if (t.value.length === 4) { submitPostcode(); }
  });
  /* The theme swaps the filter forms on every change, which would drop keyboard focus: put it back on the same box. */
  var lastFilter = '';
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.name || t.name.indexOf('filter.') !== 0) { return; }
    lastFilter = t.id || '';
    track('filter_change', { param: t.name, value: t.value, on: !!t.checked, page: page() });
  }, true);
  document.addEventListener('theme:loading:end', function () {
    paintAll();
    if (lastFilter) {
      var el = document.getElementById(lastFilter); lastFilter = '';
      if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }
  });
  /* Learn's chips, or another tab. */
  document.addEventListener('hvs:zone', function (e) {
    var z = e.detail && e.detail.zone;
    if (z) { afterZone(z); } else { paintAll(); }
    if (sheetData) { fillSheet(); }
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { paintAll(); } });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { paintAll(); } });

  function init() {
    var sp = new URLSearchParams(window.location.search), q = sp.get('zone'), sow = sp.get('sow');
    if (q && zoneOf(q)) { try { localStorage.setItem(KEY, q); } catch (e) {} }
    var z = zone();
    document.documentElement.setAttribute('data-hvs-zone', z || '');
    paintAll();
    /* Similar Products and Recently viewed arrive by fetch, and a change of size redraws the block around the price. A section that
       arrives that way cannot run a script of its own. The check is one selector, and it paints only what has not been painted,
       inside the same task, so a redrawn line is never seen empty. */
    if (window.MutationObserver) {
      new MutationObserver(function () { if ($('[data-hvs-sline]:not([data-hvs-painted])')) { paintBands(); } }).observe(document.body, { childList: true, subtree: true });
    }
    /* A link that always means this month, for emails and ads: ?sow=now, with ?zone= if it knows the zone. */
    if (sow === 'now') {
      var clean = hrefWith(function (p) { p.delete('sow'); p.delete('zone'); });
      if (window.history.replaceState) { window.history.replaceState({}, '', clean); }
      if (zoneOf(z)) { var tg = nowTarget(z, counts()); if (tg && !tg.on) { toggleMonth(z, tg.m, true); } }
      else { pendingSow = true; openClimate(); }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  window.HVSClimate = { paintAll: paintAll, zone: zone };
})();
